<template>
  <div>
    <v-card-text>
      <v-form ref="registerForm">
        <v-text-field
          outlined
          :disabled="isLoading"
          v-model="newUser.client_contact_name"
          :label="$t('form.login.name')"
          id="phone"
          validate-on-blur
          :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
          required
          @keyup.enter="register"
        ></v-text-field>

        <v-text-field
          outlined
          :disabled="isLoading"
          autocomplete="email"
          v-model="newUser.client_email"
          :label="$t('form.login.email')"
          id="email"
          validate-on-blur
          :rules="[
            (v) => !!v || $t('form.validationErrors.field_is_required'),
            (v) =>
              isValidEmail(v) || $t('form.validationErrors.email_not_valid'),
          ]"
          required
          @keyup.enter="register"
        ></v-text-field>

        <v-text-field
          type="password"
          ref="password"
          :disabled="isLoading"
          outlined
          v-model="newUser.password"
          validate-on-blur
          :label="$t('form.login.password')"
          required
          :rules="[
            (v) => !!v || $t('form.validationErrors.field_is_required'),
            (v) =>
              (v && v.length >= 8) ||
              $t('form.validationErrors.min_length', [8]),
          ]"
          append-icon="fa-key"
          id="password"
          name="password"
          @keyup.enter="register"
        ></v-text-field>

        <v-text-field
          type="password"
          ref="password_confirmation"
          :disabled="isLoading"
          outlined
          v-model="newUser.password_confirmation"
          validate-on-blur
          :label="$t('form.login.password_confirmation')"
          required
          :rules="[
            (v) => !!v || $t('form.validationErrors.field_is_required'),
            (v) =>
              v === newUser.password ||
              $t('form.validationErrors.password_confirmation_doesnt_match'),
          ]"
          append-icon="fa-key"
          id="password_confirmation"
          name="password_confirmation"
          @keyup.enter="register"
        ></v-text-field>

        <v-divider class="mt-5"></v-divider>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <language-switcher class="mb-1" />
      <v-spacer></v-spacer>
      <v-btn
        :disabled="isLoading"
        :loading="isLoading"
        elevation="0"
        class="mb-2"
        min-width="100"
        color="primary"
        @click="cancel"
      >
        {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        :disabled="isLoading"
        :loading="isLoading"
        elevation="0"
        class="mb-2 mr-2"
        min-width="100"
        color="success"
        @click="register"
        @keyup.enter="register"
      >
        {{ $t("form.login.register") }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import LanguageSwitcher from "@/components/common/LanguageSwitcher";
import  isValidEmail  from "@/utils/common"
export default {
  name: "RegisterForm",
  components: { LanguageSwitcher },
  data: () => ({
    newUser: {
      password: null,
      password_confirmation: null,
      client_contact_name: null,
      client_email: null,
      client_lang: null,
    },
    step:1,
  }),
  computed: {
    ...mapFields("auth", ["authenticated", "isLoading"]),
  },
  methods: {
    isValidEmail(email) {
      return isValidEmail(email)
    },
    register() {
      if (this.$refs["registerForm"].validate()) {
        this.newUser.client_lang = this.$i18n.locale
        this.$store.dispatch("auth/register", this.newUser).then(result=>{
          if(result){
            this.$router.push({ name: 'Sites' })
          }
        })
      }
    },
    cancel() {
      this.$refs["registerForm"].resetValidation();
      this.$emit("cancel");
      this.newUser = {
        password: null,
        password_confirmation: null,
        client_contact_name: null,
        client_email: null,
      };
    },
  },
};
</script>

<style scoped></style>
